import { render, staticRenderFns } from "./PurimAddHours.vue?vue&type=template&id=6ce5335c&"
import script from "./PurimAddHours.vue?vue&type=script&lang=js&"
export * from "./PurimAddHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports